/**
 * Created by Pankaj on 27-Nov-2019
 */
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";

export class RomanEmpireGameMode extends GameMode {
    public static readonly GENIE_RESPIN: string = "GENIE_RESPIN";
}